// src/components/ConclusionTab.js
import React, { useState, useEffect } from 'react';

const ConclusionTab = ({ formData, onChange }) => {
  const [conclusion, setConclusion] = useState(formData.conclusion || '');

  useEffect(() => {
    setConclusion(formData.conclusion || '');
  }, [formData.conclusion]);

  const handleConclusionChange = (e) => {
    const updatedConclusion = e.target.value;
    setConclusion(updatedConclusion);
    onChange({ conclusion: updatedConclusion });
  };



  return (
    <div className='tab-styling'>
      <p className='synopsis-paragraph'>How does your story end? Try to avoid typing out the ending for every plot point. The key is to provide information on how the OVERALL plot ends. Based on your main problem and how it is solved, what happens? After the hero defeats the antagonist do they live happily ever after or do they end up with a broken car that hurls them over a cliff?</p>
      <div className="nice-form-group">
      <label>Conclusion:</label>
      <textarea value={conclusion} onChange={handleConclusionChange} />

      </div>
   
      <p className='synopsis-paragraph'>Are you done? Click the button to open a new window which will show your synopsis. You can generate a new one as many times as needed.</p>
      <div className="nice-form-group">
      
      </div>
    </div>
  );
};

export default ConclusionTab;
